import { useRef } from 'react'
import * as THREE from 'three'
import { COLORS } from '../../utils/constants'

interface TreeTrunkProps {
  progress: number
}

export function TreeTrunk({ progress }: TreeTrunkProps) {
  const trunkRef = useRef<THREE.Mesh>(null)
  
  // 树干在成形时显示，混沌时隐藏
  const opacity = progress
  const scale = 0.5 + progress * 0.5
  
  return (
    <group>
      {/* 主树干 */}
      <mesh 
        ref={trunkRef}
        position={[0, -0.5, 0]}
        scale={[scale, 1, scale]}
      >
        <cylinderGeometry args={[0.3, 0.5, 2, 16]} />
        <meshStandardMaterial 
          color="#4a3728"
          roughness={0.9}
          metalness={0.1}
          transparent
          opacity={opacity}
        />
      </mesh>
      
      {/* 树根装饰 */}
      <mesh position={[0, -1.3, 0]} scale={[scale, 0.5, scale]}>
        <cylinderGeometry args={[0.6, 0.8, 0.5, 16]} />
        <meshStandardMaterial 
          color="#3d2e1f"
          roughness={0.95}
          metalness={0.05}
          transparent
          opacity={opacity}
        />
      </mesh>
      
      {/* 底座 - 金色装饰环 */}
      <mesh position={[0, -1.5, 0]} scale={[scale, 1, scale]}>
        <torusGeometry args={[1, 0.1, 16, 32]} />
        <meshStandardMaterial 
          color={COLORS.gold.bright}
          roughness={0.2}
          metalness={0.8}
          transparent
          opacity={opacity}
        />
      </mesh>
      
      {/* 底座平台 */}
      <mesh position={[0, -1.6, 0]} scale={[scale, 1, scale]}>
        <cylinderGeometry args={[1.2, 1.4, 0.2, 32]} />
        <meshStandardMaterial 
          color="#2d1f14"
          roughness={0.8}
          metalness={0.2}
          transparent
          opacity={opacity}
        />
      </mesh>
    </group>
  )
}